export function ConflictBanner(props: { visible: boolean; onReload: () => void }) {
  if (!props.visible) return null;
  return (
    <div style={{
      position: 'fixed', top: 12, left: '50%', transform: 'translateX(-50%)',
      background: 'var(--amber-bg)', color: 'var(--amber-text)',
      padding: '10px 16px', borderRadius: 12, fontSize: 13, fontWeight: 600,
      boxShadow: '0 4px 12px rgba(0,0,0,0.12)', zIndex: 1000,
    }}>
      Your spouse edited this; the local changes were not saved.{' '}
      <button onClick={props.onReload} style={{
        marginLeft: 8, background: 'var(--pink-deep)', color: 'white',
        border: 'none', borderRadius: 6, padding: '4px 10px',
      }}>Reload</button>
    </div>
  );
}
